/**
 * removeDuplicateItems returns a new array with all duplicated items removed.
 * @param {Array} array the array to remove diplicated items from.
 * @returns an array with duplicates removed.
 * @example
 * let items = [ 1, 1, 2, 3, 4, 5, 5 ];
 * let noDuplicates = removeDuplicateItems( items );
 * // [ 1, 2, 3, 4, 5 ];
 */
function removeDuplicateItems( array: Array<any> ): Array<any> {
    return Array.from( new Set( array ) );
}

export {
    removeDuplicateItems,
};
